import {create} from "zustand";
import { TenantListItemResponseDto } from '@/features/superAdmin/features/tenants/types/superAdmin-tenants-dto';

const DEFAULT_PAGE_SIZE = 10;

type TenantsFilterType = {
    filter: {
        take: number;
        skip?: number;
        orderBy?: Capitalize<keyof TenantListItemResponseDto> | null;
        orderDirection: 'asc' | 'desc';
    },
    setFilter: ( filter: Partial<TenantsFilterType['filter']> ) => void;
    resetFilter: () => void;
};

const defaultState: TenantsFilterType['filter'] = {
    take: DEFAULT_PAGE_SIZE,
    skip: 0, 
    orderBy: null, 
    orderDirection: 'asc', 
};

export const useTenantsFilter = create<TenantsFilterType>((set) => ({
    filter: {...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ 
            filter: {...defaultState },
        });
    },
}));